import styled from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint } from 'react-components'

export const CardContainerDesktop = styled.div`
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        display: ${props => props.theme.style.display.flex};
        flex-direction: ${props => props.theme.style.flexDirection.row};
        justify-content: ${({ theme }) => theme.style.justifyContent.center};
    }
`

export const PrimaryFAQCardContainer = styled.div`
    margin: 1.875rem 0.46875rem 1.25rem;
    min-height: 20.4rem;
    display: grid;
    @media only screen and (min-width: 345px) {
        min-height: auto;
    }
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin: 2.5rem 0.625rem 1.875rem;
        min-height: 18rem;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        margin: ${props => props.theme.layout.medium} 1.56rem 0 1.56rem;
        min-height: 17.1rem;
        max-width: 21rem;
    }
`

export const CardContentContainer = styled.div`
    display: ${props => props.theme.style.display.flex};
    flex-direction: ${props => props.theme.style.flexDirection.column};
    align-items: ${({ theme }) => theme.style.alignItems.center};
    padding: 1.5625rem 1.25rem 1.25rem;
`

export const TitleContainer = styled.h3`
    color: ${props => props.theme.colors.tfwBlack87};
    font-family: ${props => props.theme.typography.font.family.yummo};
    font-weight: normal;
    font-size: 1.375rem;
    line-height: 1.18;
    margin: 1.6875rem 0 ${({ theme }) => theme.spacing.medium};
    text-align: ${props => props.theme.style.textAlign.center};
    min-height: 4.875rem;
    @media only screen and (min-width: 345px) {
        min-height: 3.25rem;
    }
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: 1.5rem;
        margin: ${({ theme }) => theme.spacing.medium} 0 1.25rem;
        min-height: 3.5rem;
        @media only screen and (min-width: 800px) {
            width: 21.25rem;
        }
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        font-size: ${props => props.theme.typography.font.size.xLarge};
        width: inherit;
        min-height: 5.2rem;
    }
    @media only screen and (min-width: 1074px) {
        min-height: auto;
    }
`
